import { SecondaryNavGroup, SecondaryNavItem } from 'common/SecondaryNavigation/SecondaryNavigation.types';
import { isSecondaryNavGroup } from 'common/SecondaryNavigation/utils/guards';

export function withNestedRoutePath(
  parentGroupItem: { groupPath: string },
  subroute: SecondaryNavItem
): SecondaryNavItem;
export function withNestedRoutePath(
  parentGroupItem: { groupPath: string },
  subroute: SecondaryNavGroup
): SecondaryNavGroup;
export function withNestedRoutePath(
  parentGroupItem: { groupPath: string },
  subroute: SecondaryNavItem | SecondaryNavGroup
): typeof subroute;
export function withNestedRoutePath(
  parentGroupItem: { groupPath: string },
  subroute: SecondaryNavItem | SecondaryNavGroup
): typeof subroute {
  if (isSecondaryNavGroup(subroute)) {
    return {
      ...subroute,
      groupPath: `${parentGroupItem.groupPath}/${subroute.groupPath}`
    };
  }
  return {
    ...subroute,
    path: `${parentGroupItem.groupPath}/${subroute.path}`
  };
}

export function withNestedLabelAndPath(
  parentGroupItem: { label: string; groupPath: string },
  subroute: SecondaryNavItem
): SecondaryNavItem;
export function withNestedLabelAndPath(
  parentGroupItem: { label: string; groupPath: string },
  subroute: SecondaryNavGroup
): SecondaryNavGroup;
export function withNestedLabelAndPath(
  parentGroupItem: { label: string; groupPath: string },
  subroute: SecondaryNavItem | SecondaryNavGroup
): typeof subroute;
export function withNestedLabelAndPath(
  parentGroupItem: { label: string; groupPath: string },
  subroute: SecondaryNavItem | SecondaryNavGroup
): typeof subroute {
  const nextRoute = withNestedRoutePath(parentGroupItem, subroute);
  if (isSecondaryNavGroup(subroute)) {
    return {
      ...nextRoute,
      label: `${parentGroupItem.label}, ${subroute.label}`
    };
  }
  return {
    ...nextRoute,
    label: `${parentGroupItem.label}, ${subroute.label}`
  };
}
